import React, { useContext, useEffect, useState } from 'react'
import { Container, Card, Button, Row, Col, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router';

import Footer from '../../partials/Footer';
import LOADING from '../../constants/Loading';

import Star1 from '../../assets/images/penilaian/stars-5.png';
import Star2 from '../../assets/images/penilaian/stars-3.png';
import Star3 from '../../assets/images/penilaian/stars-2.png';
import Gif1 from '../../assets/images/penilaian/gif-1.gif';
import Gif2 from '../../assets/images/penilaian/gif-2.gif';
import Gif3 from '../../assets/images/penilaian/gif-3.gif';
import Finish from '../../assets/images/penilaian/button-finish.png';
import { Context } from '../../contexts/reducer/store';

const Popup = () => {

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setInterval(() => {
      setLoading(false)
    }, 3000)
  }, []);

  const [state, dispatch] = useContext(Context);
  const [result, setResult] = useState(state.mark);

  function SET_MARK(value = Number) {
    const init = { ...state };
    let __mark = init.mark
    dispatch({ type: 'SET_MARK', payload: __mark + value });
  }

  let navigate = useNavigate()
  function RESET_MARK(value = Number) {
    const init = { ...state };
    let __mark = init.mark
    dispatch({ type: 'RESET_MARK' });
    navigate('/');
  }
  
  return (
      <>
        {
          loading === true
            ? <LOADING />
            : ''
        }
        <div className="bg-result">
          <Container className="h-100">
            <Row className="h-100">
              <Col md="12" className="p-m-auto-2 my-auto">
                <Card className="card_style border-0">
                  <CardBody>
                    <Row>
                      <Col md="12" className="text-center mb-4">
                        {/* {result} */}
                      {
                        result >= 6 ? (
                          <div className="bg-gif-result-1">
                            <img src={Gif1} alt="" className="gif" />
                          </div>
                        ) : result >= 3 && result <= 5 ? (
                          <div className="bg-gif-result-2">
                            <img src={Gif2} alt="" className="gif" />
                          </div>
                        ) : result <= 2 ? (
                          <div className="bg-gif-result-3">
                            <img src={Gif3} alt="" className="gif" />
                          </div>
                        ) : (
                          ''
                        )
                      }
                      </Col>
                      <Col md="12" className="text-center mb-4">
                        {
                          result >= 6 ? (
                            <img src={Star1} alt="" className="star_img" />
                          ): result >= 3 && result <= 5 ? (
                            <img src={Star2} alt="" className="star_img" />
                          ): result <= 2 ? (
                            <img src={Star3} alt="" className="star_img" />
                          ): (
                            ''
                          )
                        }
                      </Col>
                      <Col md="12" className="text-center">
                        {
                          result >= 6 ? (
                            <p className="result-description">
                              Wah Hebat! <br />
                              Kamu memiliki pemahaman literasi digital seputar <br />
                              hoaks dan cara pencegahan dengan <strong>sangat baik</strong>
                            </p>
                          ): result >= 3 && result <= 5 ? (
                            <p className="result-description">
                              Yay!<br/>
                              Kamu <strong>cukup baik</strong> memahami literasi digital <br/>
                              seputar hoaks dan cara pencegahannya.
                            </p>
                          ): result <= 2 ? (
                            <p className="result-description">
                              Oh Tidak,<br/>
                              Kamu <strong>kurang</strong> melek cek fakta tentang hoaks nih.<br/>
                              Yuk, belajar lagi!
                            </p>
                          ): (
                            ''
                          )
                        }
                      </Col>
                      <Col md="12" className="text-center">
                        <Button onClick={() => (RESET_MARK(0))} className="border-0 bg-transparent">
                          <img src={Finish} alt="" className="w-100"/>
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <Footer/>
      </>
  );
}

export default Popup;